<template>
  <div>
    <vuetify-money
      v-if="rules == null"
      ref="controlFoco"
      :label="label"
      v-model="iModel"
      :readonly="readonly"
      :backgroundColor="$store.state.sysBackgroundColor"
      :options="options"
      :properties="properties"
    ></vuetify-money>
    <vuetify-money
      v-else
      ref="controlFoco"
      :label="label"
      v-model="iModel"
      :rules="[rulesInternas.requerido]"
      :readonly="readonly"
      :backgroundColor="$store.state.sysBackgroundColor"
      :options="options"
      :properties="properties"
    ></vuetify-money>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "Importe",
  props: {
    refocus: String,
    label: String,
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemActivo: {
        Importe: 0
      },
      rulesInternas: {
        requerido: v => (!!v && v != " ") || "Requerido"
      },
      options: {
        locale: "es-AR",
        prefix: "$ ",
        suffix: "",
        length: 10,
        precision: 2
      },
      properties: {
        ref: "controlFoco"
      }
    };
  },
  watch: {
    model() {
      this.itemActivo.Importe = this.model;
    }
  },
  computed: {
    iModel: {
      get() {
        // return this.itemActivo.Importe;
        return this.model;
      },
      set(valor) {
        this.itemActivo.Importe = Number(parseFloat(valor).toFixed(2));
        this.seleccionar();
      }
    }
  },
  created() {
    eventBus.$on("setearFocoImporte", this.setearFoco);
    eventBus.$on("inicializarImporte", this.inicializar);
    this.inicializar();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoImporte", this.setearFoco);
    eventBus.$off("inicializarImporte", this.inicializar);
  },
  methods: {
    setearFoco(ref) {
      if (ref == this.refocus) this.$refs.controlFoco.$refs.controlFoco.focus();
    },
    inicializar() {
      this.itemActivo.Importe = 0;
    },
    seleccionar() {
      this.$emit("seleccionarItem", this.itemActivo);
    }
  }
};
</script>
